import { IconPicker } from '../components/IconPicker';
import { toKebabCase } from '../featureFormConstants';
import { SOVEREIGN } from '../../../epc/utils/epcProjectVisual';
import type { FeatureFormApi } from '../useFeatureForm';

export function BasicsStep({ form }: { form: FeatureFormApi }) {
  const { name, setName, key, setKey, setKeyManual, keyManual, icon, setIcon, errors, lockKey } = form;
  return (
    <div className="space-y-5">
      <p
        className="text-sm"
        style={{ color: SOVEREIGN.kpiCaption }}
      >
        Give the feature a name and a unique key, and pick an icon for the sidebar.
      </p>

      <div>
        <label
          className="block text-xs font-semibold mb-1"
          style={{ color: SOVEREIGN.ink }}
        >
          Feature Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="e.g., Project Master, Asset Reports"
          className="w-full px-3 py-2 text-sm rounded-lg focus:ring-2 focus:outline-none transition-colors"
          style={
            errors.name
              ? { border: '1px solid #fca5a5', background: '#fff', color: SOVEREIGN.ink }
              : { border: `1px solid ${SOVEREIGN.inputBorder}`, background: SOVEREIGN.inputBg, color: SOVEREIGN.ink }
          }
        />
        {errors.name && <p className="text-xs text-red-600 mt-1">{errors.name}</p>}
      </div>

      <div>
        <label
          className="block text-xs font-semibold mb-1"
          style={{ color: SOVEREIGN.ink }}
        >
          Feature Key <span className="text-red-500">*</span>
          <span
            className="ml-2 font-normal"
            style={{ color: SOVEREIGN.kpiCaption }}
          >
            — unique identifier{lockKey ? ' (locked)' : ''}
          </span>
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            value={key}
            disabled={lockKey}
            onChange={e => { setKey(e.target.value); setKeyManual(true); }}
            placeholder="e.g., project-master"
            className="flex-1 px-3 py-2 text-sm font-mono rounded-lg focus:ring-2 focus:outline-none transition-colors"
            style={
              lockKey
                ? { border: `1px solid ${SOVEREIGN.innerRule}`, background: SOVEREIGN.paper, color: SOVEREIGN.kpiCaption }
                : errors.key
                  ? { border: '1px solid #fca5a5', background: '#fff', color: SOVEREIGN.ink }
                  : { border: `1px solid ${SOVEREIGN.inputBorder}`, background: SOVEREIGN.inputBg, color: SOVEREIGN.ink }
            }
          />
          {!lockKey && keyManual && (
            <button
              type="button"
              onClick={() => { setKeyManual(false); setKey(toKebabCase(name)); }}
              className="px-3 py-2 text-xs rounded-lg transition-colors"
              style={{
                border: `1px solid ${SOVEREIGN.cardBorder}`,
                background: SOVEREIGN.inputBg,
                color: SOVEREIGN.kpiCaption,
              }}
            >
              Auto
            </button>
          )}
        </div>
        {errors.key && <p className="text-xs text-red-600 mt-1">{errors.key}</p>}
        {!lockKey && (
          <p
            className="text-xs mt-1"
            style={{ color: SOVEREIGN.kpiCaption }}
          >
            Lowercase letters, numbers, hyphens only
          </p>
        )}
      </div>

      <div>
        <div className="flex items-center gap-2 mb-2">
          <label
            className="text-xs font-semibold"
            style={{ color: SOVEREIGN.ink }}
          >
            Icon <span className="text-red-500">*</span>
          </label>
          {errors.icon && <span className="text-xs text-red-500">— {errors.icon}</span>}
        </div>
        <IconPicker value={icon} onChange={setIcon} />
      </div>
    </div>
  );
}
